module.exports = __webpack_public_path__ + "img/NF.698de858.jpg";